<div class="page">
  <app-page-header
    itemName=""
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>

  <div class="page-content">
    <!-- <mat-card class="card-no-padding">
      <mat-card-content>
        <div class="img-container">
          <img src="{{ coverImage }}" class="img-responsive" alt=""/>
        </div>
      </mat-card-content>
    </mat-card> -->

    <mat-card class="mt-4">
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <div class="row">
          <div class="col-4 property-info">
            <div class="img-container">
              <img src="{{ coverImage }}" class="img-responsive" alt=""/>
            </div>
          </div>
          <div class="col-4 card-middle property-info">
            <div class="row mt-2">
              <div class="col"><h4>{{ property.get('name') }}</h4></div>
            </div>
            <div class="row mt-3">
              <div class="col">
                {{ 'properties.home.address' | translate }}
                <strong>{{ addressString }}</strong>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                {{ 'properties.home.taxCode' | translate }}
                <strong>{{ property.get('taxCode') }}</strong>
              </div>
              <div class="col-6" *ngIf="property.get('administrationStartDate') && property.get('administrationEndDate')">
                {{ 'properties.home.accountingPeriod' | translate }}
                <strong>{{ property.get('administrationStartDate') | date: 'dd/MM' }}-{{ property.get('administrationEndDate') | date: 'dd/MM' }}</strong>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col">
                {{ 'properties.home.documentsPresent' | translate }}
                <strong>{{ property.get('totalDocsInserted') }}</strong>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col">
                {{ 'properties.home.missingMandatoryDocuments' | translate }}
                <strong>{{ property.get('totalDocsMissingMandatory') }}</strong>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col">
                {{ 'properties.home.documentsWithExpiration' | translate }}
                <strong>{{ property.get('totalDocsWithExpiration') }}</strong>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col">
                {{ 'properties.home.mappingStatus' | translate }}
                <span *ngIf="mappaturaOpen" class="mapping-chip-container">
                  <span class="chip-green mapping-chip"></span>
                  <span><strong>{{ 'common.words.openFemale' | translate }}</strong></span>
                </span>
                <span *ngIf="!mappaturaOpen" class="mapping-chip-container">
                  <span class="chip-red mapping-chip"></span>
                  <span><strong>{{ 'common.words.closedFemale' | translate }}</strong></span>
                </span>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col">
                {{ 'properties.home.lastEdit' | translate }}
                <strong>{{ lastMappingEditDate | date }}</strong>
              </div>
            </div>
            <div class="row mt-3" *ngIf="loggedUserAdmin && mappingInfoReady">
              <div class="col">
                {{ 'properties.home.mapper' | translate }}
                <strong>{{ mappatore || ('properties.home.mapperNotPresent' | translate) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-4 property-info">
            <!-- «SCARICA»: once the switch is live, the four exports come from the new archive, with the rules of its «Esporta» menu (downloadMenu) -->
            <div class="row mt-2" *ngIf="downloadColumnShown">
              <div class="col">
                <h6>{{ 'properties.home.download' | translate }}</h6>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared && downloadMenu.inserted">
              <div class="col">
                <a mat-button (click)="onExport('insertedDocs2025', propertyId)" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.mandatory' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared && downloadMenu.missing">
              <div class="col">
                <a mat-button (click)="onExport('missingDocs', propertyId)" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.missingMandatory' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared && downloadMenu.ras">
              <div class="col">
                <a mat-button (click)="onExportRAS()" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.ras' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col" *ngIf="loggedUserAdmin && downloadMenu.contracts">
                <a mat-button (click)="onExportContracts()" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.contracts' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col" *ngIf="loggedUserAdmin && propertyPrivacyActive">
                <a mat-button (click)="onOpenPrivacyDocsDialog()" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.privacyDocs' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row mt-3" *ngIf="!loggedUserTemporary && !loggedUserShared">
              <div class="col" *ngIf="loggedUserMaster && propertyPrivacySagActive">
                <a mat-button (click)="onDownloadDataProcessorAppointment()" class="download-section">
                  <div class="row">
                    <div class="col-10 text-left">{{ 'properties.home.export.dataProcessorAppointment' | translate }}</div>
                    <div class="col-2 text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Guests' buttons: the legacy pages until the switch, the new archive after it (FEX-29) -->
    <div *ngIf="loggedUserTemporary || loggedUserShared">
      <div class="row mt-4">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button [routerLink]="guestArchiveRoute" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.documentaryFileArchive' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4" *ngIf="guestSearchShown">
          <mat-card class="card-no-padding">
            <a mat-button [routerLink]="guestSearchRoute" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.searchDocuments' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding" *ngIf="!masterAndSubscriptionPrivacy && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC' && currentRole && currentRole.propertiesPermission && currentRole.propertiesPermission.mappatura">
            <a mat-button routerLink="../../{{ propertyId }}/mapping" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.propertyMapping' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Staff's buttons: «Ricerca documenti» and «Inserisci nuovo documento» follow the rules of the new archive once it is live (FE-A1) -->
    <div *ngIf="!loggedUserTemporary && !loggedUserShared">
      <div class="row mt-4">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a *ngIf="mappaturaOpen && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'" mat-button (click)="onGoToDocumentArchive()" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.documentaryFileArchive' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>

            <a *ngIf="(mappaturaOpen && (subscriptionType ==='FREE' || subscriptionType ==='FREEBASIC')) || (!mappaturaOpen && subscriptionType !=='noSubscription')" mat-button routerLink="../../{{ propertyId }}/documents" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.documentaryFileArchive' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding" *ngIf="property && loggedUserPermissions.includes('canReadPropertiesExpirationsList') && (loggedUserAdmin || (loggedUserMaster && subscriptionDocumentUpload)) && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag">
            <a mat-button routerLink="../../{{ propertyId }}/documentsWithExpiration" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.listOfDocumentsWithExpiration' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
          <mat-card class="card-no-padding" *ngIf="!(property && loggedUserPermissions.includes('canReadPropertiesExpirationsList') && (loggedUserAdmin || (loggedUserMaster && subscriptionDocumentUpload)) && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag) && staffSearchShown">
            <a mat-button routerLink="../../{{ propertyId }}/search" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.searchDocuments' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding" *ngIf="property && loggedUserPermissions.includes('canReadPropertiesExpirationsList') && (loggedUserAdmin || (loggedUserMaster && subscriptionDocumentUpload)) && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag && staffSearchShown">
            <a mat-button routerLink="../../{{ propertyId }}/search" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.searchDocuments' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>

      <div class="row mt-4" *ngIf="!masterAndSubscriptionPrivacy && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/mapping" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.propertyMapping' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/detail2" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.personalData' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/caretakers" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.custodiansCleaningCompanies' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>
      <div class="row mt-4" *ngIf="subscriptionType ==='FREE' || subscriptionType ==='FREEBASIC'">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/detail2" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.personalData' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/caretakers" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.custodiansCleaningCompanies' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/latestDocumentsInserted" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.latestDocumentsInserted' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding" *ngIf="loggedUserAdmin || (loggedUserMaster && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag)">
            <a mat-button routerLink="../../{{ propertyId }}/condominiumAccess" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.condominiumAccess' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
          <mat-card class="card-no-padding" *ngIf="!masterAndSubscriptionPrivacy && !(loggedUserAdmin || (loggedUserMaster && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag)) && staffInsertShown">
            <a mat-button routerLink="../../{{ propertyId }}/addNewDocuments" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.insertNewDocument' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding" *ngIf="!masterAndSubscriptionPrivacy && (loggedUserAdmin || (loggedUserMaster && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag)) && staffInsertShown">
            <a mat-button routerLink="../../{{ propertyId }}/addNewDocuments" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.insertNewDocument' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
          <mat-card class="card-no-padding" *ngIf="masterAndSubscriptionPrivacy && staffInsertShown">
            <a mat-button routerLink="../../{{ propertyId }}/addDocuments" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.insertNewDocument' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>

      <div class="row mt-4" *ngIf="loggedUserAdmin">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/status" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.status' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/balances" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.accounts' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/notesContractualAgreements" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.notesContractualAgreements' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>

      <div class="row mt-4" *ngIf="loggedUserMaster">
        <div class="col-4" *ngIf="!masterOnlySuppliers">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/propertyPropertyTangNfc" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.propertyTagNfc' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          
        </div>
        <div class="col-4">
          
        </div>
      </div>

      <div class="row mt-4" *ngIf="loggedUserAdmin">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/propertyPropertyTangNfc" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.propertyTagNfc' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button routerLink="../../{{ propertyId }}/propertyPropertyTagNfcList" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.tagNfcList' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
        <div class="col-4">
          <mat-card class="card-no-padding">
            <a mat-button (click)="onExportFile()" class="button-section pt-3 pb-3">
              <div class="row">
                <div class="col-10 text-left">{{ 'properties.home.btns.downloadDocumentFileArchive' | translate }}</div>
                <div class="col-2 text-right">
                  <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                </div>
              </div>
            </a>
          </mat-card>
        </div>
      </div>

      <div class="row mt-4" *ngIf="loggedUserAdmin">
        <div class="col-4">
          <mat-card class="card-no-padding">
            <div *ngIf="propertyData && propertyData.active">
              <a mat-button (click)="onDelete()" class="button-section pt-3 pb-3">
                <div class="row">
                  <div class="col-10 text-left">{{ 'properties.home.btns.deactivateProperty' | translate }}</div>
                  <div class="col-2 text-right">
                    <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                  </div>
                </div>
              </a>
            </div>
            <div *ngIf="propertyData && !propertyData.active">
              <a mat-button (click)="onReactivate()" class="button-section pt-3 pb-3">
                <div class="row">
                  <div class="col-10 text-left">{{ 'properties.home.btns.reactivateProperty' | translate }}</div>
                  <div class="col-2 text-right">
                    <mat-icon color="primary" fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                  </div>
                </div>
              </a>
            </div>
          </mat-card>
        </div>
        
      </div>
    </div>

    
  </div>
</div>
